
export default {
  name: 'sgh-generic-loader',
  props: {
    showLoader: {
      type: Boolean,
      default: false,
    },
  },
}
